var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/grey_chevron_right.2df0ada1.png","uri@2x": __webpack_public_path__ + "static/media/grey_chevron_right.c4c7ff81.png","uri@3x": __webpack_public_path__ + "static/media/grey_chevron_right.864df94e.png",
    width: 20,
    height: 20
});